import * as types from './actionTypes';
import store from './../store';
import {loaderEnable} from "../bvcomponents/ui/loaderView";
import * as uuid from "uuid";
import {hashHistory} from "react-router";

import {showOrderCompletePopup} from "./shoppingCartFunctions";
import {CART_ITEM_ADDED_BY} from "../bvcomponents/shoppingCart/cartItemInterface";
import {
  getAvailableSteps, getCorrectedWizardGroupForFeature,
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {
  getWizardStepFromCartItemFeature
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {USE_FAB_FILTERS_ONLY, USE_NEW_CANVAS} from "../config";
import {getBundledFeatures} from "../bvcomponents/look/lookNavigation/lookFunctions2";
import {IS_QKB_UI} from "../config";
// import {showContractSigning} from "./contractsActions";
import {shouldUseContractSigning} from "../bvcomponents/popups/contractSign/contractsFunctions";
import {ROUTES} from "../routes";
import {syncCartFeatureToSqftCalcData} from "../bvcomponents/sqft/helpers/syncCartFeatureToSqftCalcData";

//****** SERVER & GLOBAL ******//
export const setWindowWidth = (windowWidth) => ({
  type: types.SET_WINDOW_WIDTH,
  payload: {
    windowWidth
  }
});
export const setJavascriptErrors = (javascriptError) => ({
  type: types.SET_JAVASCRIPT_ERRORS,
  payload: {javascriptError}
});
export const setWindowHeight = (windowHeight) => ({
  type: types.SET_WINDOW_HEIGHT,
  payload: {
    windowHeight
  }
});
export const setStonePricing = (stonePricing) => ({
  type: types.SET_STONE_PRICING,
  payload: {
    stonePricing
  }
});
export const setCookieAccepted = (cookieAccepted) => ({
  type: types.SET_COOKIE_ACCEPTED,
  payload: {
    cookieAccepted
  }
});
export const addVisualizersLoaded = (newLoadedVisualizer) => ({
  type: types.ADD_VISUALIZERS_LOADED,
  payload: {
    newLoadedVisualizer
  }
});
export const showSuccessNotification = (successNotification) => ({
  type: types.SHOW_SUCCESS_NOTIFICATION,
  payload: successNotification
});
export const addProjectDocument = (file, description, sqftDiagram = false) => {

  let documents = store.getState().serverState.documents;
  const newDocument = {
    name: file.name,
    uid: uuid.v4(),
    text: description,
    created: new Date(),
    uploaded: false,
    file: file // the blob file
  };

  if (sqftDiagram) {
    const existingCalcDiagramIndex = documents.findIndex(doc => doc.name === file.name);
    if (existingCalcDiagramIndex > -1) {
      documents.splice(existingCalcDiagramIndex, 1);
    }
  }

  return {
    type: types.ADD_PROJECT_DOCUMENT,
    payload: [...documents, newDocument]
  }
};
export const setProjectDocumentsIds = (documents) => {

  let oldDocuments = store.getState().serverState.documents;
  oldDocuments = oldDocuments.map(oldDoc => {
    const responseDoc = documents.find(doc => doc.name === oldDoc);
    if (responseDoc) {
      oldDoc.uploaded = true;
      oldDoc.documentId = responseDoc.documentId;
    }
    return oldDoc
  });

  return {
    type: types.SET_PROJECT_DOCUMENTS_IDS,
    payload: [...oldDocuments]
  }
};

/**
 * @param jobId {int}
 */
export const setJobId = (jobId) => ({type: types.SET_JOB_ID, payload: {jobId}});

//****** STEPS ******//
export const setStep = (activeStep) => ({
  type: types.SET_STEP,
  payload: {
    activeStep
  }
});
export const setLayoutDataParts = (layoutParts) => ({
  type: types.SET_LAYOUT_DATA_PARTS,
  payload: {
    layoutParts
  }
});
export const setStepSwitching = (isSwitching) => ({
  type: types.SET_STEP_SWITCHING,
  payload: {
    isSwitching
  }
});

//****** SELECTION ******//
export const toggleSelectionWindow = (selectionOpened, selectionGroup) => {

  const {filterState} = store.getState();
  if (filterState.showFilters) {
    store.dispatch(showFilters(false));
  }

  return {
    type: types.TOGGLE_SELECTION_WINDOW,
    payload: {
      selectionOpened,
      selectionGroup
    }
  };
};
export const setDefaultSelectionGroup = (selectionGroup) => ({
  type: types.SET_DEFAULT_SELECTION_GROUP,
  payload: {selectionGroup}
});
export const setSelectionWindowView = (selectionWindowView) => ({
  type: types.SET_SELECTION_WINDOW_VIEW,
  payload: {selectionWindowView}
});
export const toggleSelectionFeatureInfo = (selectionFeatureInfo) => ({
  type: types.TOGGLE_SELECTION_INFO,
  payload: {selectionFeatureInfo}
});
export const updateFeatureInfoCount = () => ({
  type: types.UPDATE_FEATURE_INFO_COUNT,
});
export const changeSelectionInfoQuantity = (selectionInfoQuantity) => ({
  type: types.CHANGE_SELECTION_INFO_QUANTITY,
  payload: {selectionInfoQuantity}
});
export const togglePulseFeatureInfoQuantity = (pulseFeatureInfoQuantity) => ({
  type: types.TOGGLE_PULSE_FEATURE_INFO_QUANTITY,
  payload: {pulseFeatureInfoQuantity}
});
export const togglePulseFeatureInfoNote = (pulseFeatureInfoNote) => ({
  type: types.TOGGLE_PULSE_FEATURE_INFO_NOTE,
  payload: {pulseFeatureInfoNote}
});
export const changeMaterialsInfoFeatureModules = (materialsInfoFeatureModules) => ({
  type: types.CHANGE_MATERIALS_INFO_FEATURE_MODULES,
  payload: {materialsInfoFeatureModules}
});
export const changeActivePartRelatedItemIndex = (newActivePartRelatedItemIndex) => {
  return (dispatch, getState) => {
    const store = getState();
    const {activePartRelatedItemIndex} = store.selectionState;
    dispatch({
      type: types.CHANGE_SELECTION_ACTIVE_PART_RELATED_INDEX,
      payload: {
        activePartRelatedItemIndex: newActivePartRelatedItemIndex,
        isSameStep: newActivePartRelatedItemIndex === activePartRelatedItemIndex
      }
    });
  }
}
export const setActiveFeature = (activeFeature) => ({
  type: types.SET_ACTIVE_FEATURE,
  payload: {activeFeature}
});
export const toggleShowDescriptionCover = (showDescriptionCover) => ({
  type: types.TOGGLE_SHOW_DESCRIPTION_COVER,
  payload: {showDescriptionCover}
});

//****** BATHROOM VISUALIZER COMMANDS ******//
export const toggleBathroomVisualizerOpen = (bvOpened) => {
  const {filterState, bathroomVisualizerState} = store.getState();
  if (filterState.showFilters) {
    store.dispatch(showFilters(false));
  }
  if (bvOpened && !bathroomVisualizerState.bvVisited && !USE_NEW_CANVAS) {
    loaderEnable();
  }
  return {
    type: types.TOGGLE_BATHROOM_VISUALIZER_OPEN,
    payload: {
      bvOpened
    }
  };
};
export const setBathroomVisualizerVisited = () => {
  return {
    type: types.SET_BATHROOM_VISUALIZER_VISITED,
    payload: {
      bvVisited: true
    }
  };
};
export const setBathroomVisualizerFeatures = (bvFeatures) => ({
  type: types.SET_BV_FEATURES,
  payload: {bvFeatures}
});
export const setBathroomVisualizerPresets = (bvPresets, visualizerType = document.kvConfig.visualizerType) => ({
  type: types.SET_BV_PRESETS,
  payload: {bvPresets, visualizerType}
});
export const setActivePreset = (activePreset = 0) => ({
  type: types.SET_ACTIVE_PRESET,
  payload: {activePreset}
});
export const setCanvasId = (id) => ({type: types.SET_BV_CANVAS_ID, payload: {id}});
export const toggleShowRestorePopup = (showRestorePopup) => ({
  type: types.TOGGLE_SHOW_RESTORE_POPUP,
  payload: {showRestorePopup}
});
export const setCanvasDimensions = (canvasDimensions = null) => ({
  type: types.SET_CANVAS_DIMENSIONS,
  payload: {canvasDimensions}
});
export const setCanvasScale = (canvasScale = 1) => ({
  type: types.SET_CANVAS_SCALE,
  payload: {canvasScale}
});
export const setLoadedPresets = (loadedPresets = []) => ({
  type: types.SET_LOADED_PRESETS,
  payload: {loadedPresets}
});

//****** LOADER ******//
export const toggleLoader = (loaderOpened, loaderText = "loader.defaultText", loaderTitle = "loader.defaultTitle", loaderFullScreen = false) => ({
  type: types.TOGGLE_LOADER,
  payload: {
    loaderOpened,
    loaderTitle,
    loaderText,
    loaderFullScreen,
  }
});
export const setMultiLoader = (multiLoader) => ({
  type: types.SET_MULTI_LOADER,
  payload: multiLoader
})

//****** USER COMMANDS ******//
export const toggleUserPopup = (userPopupState) => ({
  type: types.TOGGLE_USER_POPUP,
  payload: {
    ...userPopupState
  }
});
export const changeUserInfo = (userInfo) => ({
  type: types.CHANGE_USER_INFO,
  payload: {userInfo}
});
export const changeUserInfoErrors = (userInfoErrors) => ({
  type: types.CHANGE_USER_INFO_ERRORS,
  payload: {userInfoErrors}
});
export const toggleAdditionalFields = (showAdditionalFields) => ({
  type: types.TOGGLE_ADDITIONAL_FIELDS,
  payload: {showAdditionalFields}
});
export const setUserPhoneNumberValidated = (validated) => ({
  type: types.SET_USER_PHONE_NUMBER_VALIDATED,
  payload: {
    isPhoneNumberValidated: validated
  }
});
export const unlockPricing = () => {
  return (dispatch, getState) => {
    const {userState} = getState();
    const {userIsLoggedIn, isPhoneNumberValidated} = userState;
    if (!userIsLoggedIn || !isPhoneNumberValidated) {
      dispatch(toggleUserPopup({
        userPopupOpened: true
      }));
    }
  }
};

const _addBundleCartItems = (newCartItems) => {
  // on look & product journeys we have another method and relatedProductParent property for bundled features
  if (!IS_QKB_UI) {
    return newCartItems
  }
  newCartItems.forEach(newCartItem => {
    const bundleFeatures = getBundledFeatures(newCartItem.cartFeature);
    if (Array.isArray(bundleFeatures) && bundleFeatures.length) {
      bundleFeatures.forEach((bundleFeature) => {
        const quantity = newCartItem.cartFeature.dbFeature.bundledFeatureQuantities
          ? newCartItem.cartFeature.dbFeature.bundledFeatureQuantities[bundleFeature.dbFeature.id] || 1
          : 1;
        const keepTheSameQuantity = !!newCartItem?.cartFeature?.dbFeature?.bundledFeatureAlwaysSameQuantities?.[bundleFeature.dbFeature.id];
        const cartItem = Object.assign({}, newCartItem, {
          id: uuid.v4(),
          cartFeature: bundleFeature,
          partId: bundleFeature.partId,
          noteText: "",
          bundleParentId: newCartItem.id,
          quantity: keepTheSameQuantity ? quantity : quantity * newCartItem.quantity,
        });
        // console.log("parent cartItem", newCartItem);
        // console.log("bundle cartItem", cartItem);
        newCartItems.push(cartItem);
      })
    }
  });
  return newCartItems
}

//****** CART COMMANDS ******//
export const addToCart = (cartItems) => {
  return (dispatch, getState) => {
    const {quotesState, fabricatorState, wizardState, sqftState, cartState} = getState();

    const {wizardIsActive, wizardActiveItem, wizardActiveStep, wizardSelectedValues, allWizardsValues} = wizardState;
    let fromWizardId = null;
    let fromWizardGroup = null;
    let fromWizardStep = null;
    let wizardSteps = null;
    if (wizardIsActive && wizardActiveItem) {
      fromWizardId = wizardState.wizardActiveItem.id;
      fromWizardStep = wizardActiveStep;
      fromWizardGroup = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].wizardGroup
        ? wizardSelectedValues[wizardActiveStep].wizardGroup : null;
      if (sqftState.isSquareFootageEnabled) {
        wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true)
      }
    }

    let newCartItems = cartItems
      .map(cartItem => {
        cartItem.id = uuid.v4();
        cartItem.currentQuote = Number.isInteger(cartItem.currentQuote) ? cartItem.currentQuote : quotesState.activeQuoteIndex;
        cartItem.addedBy = cartItem.addedBy || CART_ITEM_ADDED_BY.user;
        cartItem.fromVisualizerType = cartItem.fromVisualizerType || document.kvConfig.visualizerType;
        if (!cartItem.noteText && cartItem.cartFeature && cartItem.cartFeature.notesList && cartItem.cartFeature.notesList[cartItem.currentQuote]) {
          cartItem.noteText = cartItem.cartFeature.notesList[cartItem.currentQuote];
        }
        if (wizardIsActive && !cartItem.fromWizardId) { // if it is not passed - add it
          if (sqftState.isSquareFootageEnabled && wizardSteps) {
            const foundStep = getWizardStepFromCartItemFeature(wizardSteps, cartItem);
            if (foundStep) {
              cartItem.fromWizardId = fromWizardId;
              cartItem.fromWizardStep = foundStep.stepIndex;
              cartItem.fromWizardGroupId = fromWizardGroup ? getCorrectedWizardGroupForFeature(foundStep.stepGroups[0], cartItem.cartFeature).id : "";
            } else {
              cartItem.fromWizardId = fromWizardId;
              cartItem.fromWizardStep = fromWizardStep;
              cartItem.fromWizardGroupId = fromWizardGroup ? getCorrectedWizardGroupForFeature(fromWizardGroup, cartItem.cartFeature).id : "";
            }
          } else {
            cartItem.fromWizardId = fromWizardId;
            cartItem.fromWizardStep = fromWizardStep;
            cartItem.fromWizardGroupId = fromWizardGroup ? getCorrectedWizardGroupForFeature(fromWizardGroup, cartItem.cartFeature).id : "";
          }
        }
        return cartItem
      })
      .filter(newCartItem => {
        if (newCartItem.partId === "room" && newCartItem.cartFeature && cartState.cartItems.some(oldCartItem => {
          return oldCartItem.cartFeature && (oldCartItem.cartFeature.dbFeature.id === newCartItem.cartFeature.dbFeature.id)
            && oldCartItem.currentQuote === newCartItem.currentQuote
        })) {
          return false // do not add duplicate room
        }
        return !cartState.cartItems.some(oldCartItem => oldCartItem.id === newCartItem.id)
          && (newCartItem.quantity > 0 || newCartItem.displayFakeQuantity > 0)
      });

    newCartItems = _addBundleCartItems(newCartItems);

    dispatch({
      type: types.ADD_TO_CART,
      payload: {
        cartItems: newCartItems,
        fabricatorState,
        allWizardsValues,
      }
    });
  }
};
export const addDisplayLogicCartItem = (cartItem, fromVisualizerType = document.kvConfig.visualizerType) => ({
  type: types.ADD_DISPLAY_LOGIC_CART_ITEM,
  payload: {
    cartItem: Object.assign({}, cartItem, {
      id: uuid.v4(),
      isAddedFromDisplayLogic: true,
      addedBy: CART_ITEM_ADDED_BY.user,
      fromVisualizerType,
    })
  }
});
export const changeCartItemQuantity = (cartItem, quantity, removeFakeQuantity = false) => {
  return (dispatch, getState) => {
    const {fabricatorState, wizardState} = getState();
    dispatch({
      type: types.CHANGE_CART_QUANTITY,
      payload: { cartItem, quantity, fabricatorState, removeFakeQuantity, allWizardsValues: wizardState.allWizardsValues }
    });
  }
};
export const removeFromCart = (cartItem) => {
  return (dispatch, getState) => {
    const {fabricatorState, wizardState} = getState();
    dispatch({
      type: types.REMOVE_FROM_CART,
      payload: { cartItem, fabricatorState, allWizardsValues: wizardState.allWizardsValues }
    });
  }
};
// Accepts array of ids OR array of cartItems
export const removeManyFromCart = (itemsOrIds) => {
  return (dispatch, getState) => {
    const { fabricatorState, wizardState } = getState();
    const ids = itemsOrIds.map(v => typeof v === 'string' ? v : v.id);

    dispatch({
      type: types.REMOVE_MANY_FROM_CART,
      payload: {
        ids,
        fabricatorState,
        allWizardsValues: wizardState.allWizardsValues,
      }
    });
  };
};
export const changeCartFeature = (cartItem, skipOtherRules = false) => {
  return (dispatch, getState) => {
    const {fabricatorState, wizardState, cartState, quotesState} = getState();
    const oldCartItem = cartState.cartItems.find(item => item.id === cartItem.id);
    const cartItems = _addBundleCartItems([cartItem]);
    dispatch({
      type: types.CHANGE_CART_FEATURE,
      payload: {cartItems, fabricatorState, allWizardsValues: wizardState.allWizardsValues, skipOtherRules}
    });

    const updatedQuotes = syncCartFeatureToSqftCalcData(quotesState.quotes, oldCartItem, cartItem);
    if (updatedQuotes !== quotesState.quotes) {
      dispatch({
        type: types.SET_QUOTES,
        payload: {quotes: updatedQuotes},
      });
    }
  }
};
export const removeInstallationServiceFromCart = installationService => ({
  type: types.REMOVE_INSTALLATION_SERVICE_FROM_CART,
  payload: {
    installationService
  }
});
export const clearCart = () => ({
  type: types.CLEAR_CART
});
export const toggleApplyPopup = (applyPopupOpened, activeApplyPopupItems = []) => ({
  type: types.TOGGLE_APPLY_POPUP,
  payload: {
    applyPopupOpened,
    activeApplyPopupItems
  }
});
export const clickQuestionNo = (questionNoClicked) => ({
  type: types.CLICK_QUESTION_NO,
  payload: {
    questionNoClicked
  }
});
export const setCameFromPage = (cameFromPage) => ({
  type: types.CAME_FROM_PAGE,
  payload: {
    cameFromPage
  }
});
export const addToRecentlyViewed = (feature) => ({
  type: types.ADD_TO_RECENTLY_VIEWED,
  payload: {
    feature
  }
});
export const showCheckoutPopup = (show) => ({
  type: types.SHOW_CHECKOUT_POPUP,
  payload: {
    show
  }
});
export const restoreCart = (cartState) => {
  return (dispatch, getState) => {
    const {fabricatorState, quotesState, wizardState} = getState();
    if (cartState && cartState.cartItems) {
      cartState.cartItems = cartState.cartItems.map(cartItem => {
        cartItem.id = cartItem.id || uuid.v4();
        cartItem.currentQuote = Number.isInteger(cartItem.currentQuote) ? cartItem.currentQuote : quotesState.activeQuoteIndex;
        cartItem.addedBy = cartItem.addedBy || CART_ITEM_ADDED_BY.user;
        return cartItem
      })
    }
    dispatch({
      type: types.RESTORE_CART,
      payload: { cartState, fabricatorState, allWizardsValues: wizardState.allWizardsValues }
    });
  }
};

//****** INSTALLATION COMMANDS ******//
export const toggleInstOpened = (instOpened) => ({
  type: types.TOGGLE_INST_OPENED,
  payload: {
    instOpened
  }
});
export const setInstList = (instList) => ({
  type: types.SET_INST_LIST,
  payload: {
    instList
  }
});
export const setDefaultInstallations = (defaultInstallations) => ({
  type: types.SET_DEFAULT_INST_LIST,
  payload: {defaultInstallations}
});

//****** TOOL STATE ***************//
export const changeStateToQuote = () => ({
  type: types.SET_STATE_TO_QUOTE
});

//****** FABRICATOR COMMANDS ******//
export const setFabricatorData = (fabricatorData) => ({
  type: types.SET_FABRICATOR_DATA,
  payload: {
    ...fabricatorData
  }
});
export const setFabricatorTaxes = (fabricatorTaxes) => ({
  type: types.SET_FABRICATOR_TAXES,
  payload: {fabricatorTaxes}
});

export const updateFabricatorSettings = () => ({
  type: types.UPDATE_FABRICATOR_SETTINGS,
});

export const toggleHideItemsSwitcher = () => ({
  type: types.TOGGLE_HIDE_ITEMS_PRICES,
});

export const toggleUseFabricatorCostPrices = (useFabricatorCostPrices) => ({
  type: types.TOGGLE_USE_FABRICATOR_COST_PRICES,
  payload: {useFabricatorCostPrices}
});

//****** MESSAGEBOX COMMANDS ******//
export const changeMessageBoxState = (messageBoxState) => ({
  type: types.CHANGE_MESSAGE_BOX,
  payload: {
    ...messageBoxState
  }
});

export const setUiPopupState = (uiPopupState) => ({
  type: types.SET_UI_POPUP_STATE,
  payload: {uiPopupState}
});

//******** FILTER COMMANDS **********//
export const setSelectedFilters = (selectedFilters) => ({
  type: types.SET_SELECTED_FILTERS,
  payload: [...selectedFilters]
});

export const loadFilters = (filterGroups) => {

  if (USE_FAB_FILTERS_ONLY) {
//     console.log("fabricator only filterGroups", filterGroups.map(fg => {
//       return Object.assign ({}, fg, {
//         values: fg.values.filter(fgValue => fgValue.isFabricatorCustomFilter)
//       })
//     }).filter(fg => fg.values.length));
    filterGroups = filterGroups.filter(fg => {
      if (!Array.isArray(fg.values) || !fg.values.length) {
        return false
      }
      fg.values = fg.values.filter(fgValue => fgValue.isFabricatorCustomFilter);
      return fg.values.length
    })
    console.log("fabricator only filterGroups", filterGroups);
  }
  return {
    type: types.LOAD_FILTERS,
    payload: filterGroups
  }
};

export const setExpandedFilters = (expandedFilters) => ({
  type: types.SET_EXPANDED_FILTERS,
  payload: expandedFilters
});

export const showFilters = (show = false, filterId = "") => ({
  type: types.SHOW_FILTERS,
  payload: {show, filterId}
});

export const showFiltersIfHidden = (filterId = "") => ({
  type: types.SHOW_FILTERS_IF_NOT_VISIBLE,
  payload: filterId
});

export const setFilterVisible = (filter) => ({
  type: types.SET_FILTER_VISIBLE,
  payload: filter
});


//********* MOBILE NAVIGATION COMMANDS *********/
export const loadMobileNav = (data) => ({
  type: types.LOAD_MOBILE_NAV,
  payload: data
});

export const hideUserPopup = () => ({
  type: types.CHANGE_MESSAGE_BOX,
  payload: {
    visible: false,
    inline: false
  }
});

export const showSchedulerPopup = show => {
  return {
    type: types.SHOW_SCHEDULER,
    payload: {show}
  }
};
export const toggleConfirmPopup = (confirmPopupOpened, confirmPopupType) => ({
  type: types.TOGGLE_CONFIRM_POPUP,
  payload: {confirmPopupOpened, confirmPopupType}
});

//********* DOCU SIGN *********/
export const showDocuSign = (show, callback = null) => ({
  type: types.SHOW_DOCUSIGN,
  payload: {show, callback}
});

export const showDeposit = (show, callback = null) => ({
  type: types.SHOW_DEPOSIT,
  payload: {show, callback}
});

const _showCheckoutPopup = (fabricatorSettings) => {
  return new Promise((resolve) => {
    if (fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway) {
      store.dispatch(showCheckoutPopup(true));
      store.dispatch(showDocuSign(false, resolve)); // we need only callback from here
    } else {
      resolve();
    }
  });
}

const _showDeposit = (fabricatorSettings) => {
  return new Promise((resolve) => {
    const state = store.getState();
    console.log("state__state", state);
    if (fabricatorSettings.enableDeposit && (!fabricatorSettings.leadCaptureShoppingCart || state.unlockCalculationsState.unlockCalculationsTutorialIsFinished)) {
      store.dispatch(showDeposit(true, resolve))
    } else {
      resolve();
    }
  });
}

const _showDocuSign = (fabricatorSettings) => {
  return new Promise((resolve) => {
    if (fabricatorSettings.enableDocuSign) {
      store.dispatch(showDocuSign(true, resolve))
    } else {
      resolve();
    }
  });
}

const _showContractSigning = (fabricatorSettings) => {
  return new Promise((resolve) => {
    if (shouldUseContractSigning(fabricatorSettings)) {
      // store.dispatch(showContractSigning(true, resolve))
      hashHistory.push(ROUTES.contract);
    } else {
      resolve();
    }
  });
};

export const checkForOrderCompletePopup = (fabricatorSettings) => {
  return new Promise((resolve) => {
    if (fabricatorSettings.checkout && (!fabricatorSettings.hasPaymentGateway || window.checkoutSuccess)) {
      store.dispatch(showOrderCompletePopup(true));
    }
    resolve();
  });
}

export const showCheckoutLayout = (fabricatorSettings) => {
  let p = _showDeposit(fabricatorSettings)
    .then(() => _showDocuSign(fabricatorSettings))
    .then(() => _showCheckoutPopup(fabricatorSettings))
    .then(() => _showContractSigning(fabricatorSettings))
    .then(() => checkForOrderCompletePopup(fabricatorSettings));
    // .then(() => printReceipt(fabricatorSettings));
  return p.catch(console.error);
}

//********* QUOTING TOOL COMMANDS *********/
export const setQtCategoriesRequested = (qtCategoriesRequested) => ({
  type: types.SET_QT_CATEGORIES_REQUESTED,
  payload: {
    qtCategoriesRequested
  }
});
export const setQtCategoriesLoaded = (qtCategoriesLoaded) => ({
  type: types.SET_QT_CATEGORIES_LOADED,
  payload: {
    qtCategoriesLoaded
  }
});
export const setQtActiveCategory = (qtActiveCategory) => ({
  type: types.SET_QT_ACTIVE_CATEGORY,
  payload: {
    qtActiveCategory
  }
});

export const setIntroVideo = (introVideo) => ({
  type: types.SET_INTRO_VIDEO,
  payload: introVideo
})

export const updateCanvasCount = () => ({
  type: types.UPDATE_CANVAS_COUNT
})

export const setPresetWasChangedByUser = (presetWasChangedByUser) => ({
  type: types.SET_PRESET_WAS_CHANGED_BY_USER,
  payload: {presetWasChangedByUser}
})

export const setFirstLoadedPreset = (firstLoadedPreset) => ({
  type: types.SET_FIRST_LOADED_PRESET,
  payload: {firstLoadedPreset}
})

export const addLayoutHistory = (layoutState) => ({
  type: types.ADD_LAYOUT_HISTORY,
  payload: {
    layoutState
  }
});

export const setLayoutHistory = (layoutHistory) => ({
  type: types.SET_LAYOUT_HISTORY,
  payload: {
    layoutHistory
  }
});
